import { useProperty, useTranslation } from '@eti/providers';
import { analytics } from '@eti/utils';
import { useRef } from 'react';
import { getPriceProps, getReadMoreLabel, getSingleChoiceProps } from '../../common/utils/productCardProps';
import { SEAT_MAP } from '../../products';
import { getMinPrice } from '../utils/selection';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useIllustration } from '../../common/utils/useIllustration';
import { useDidUpdateEffect } from '../../custom-hooks/useDidUpdateEffect';
import ChangeSelection from '../dialog/components/SeatMapChangeSelection';
import { useLinksAccessibility } from '../../custom-hooks/useLinkAccessibility';
import { jsx as _jsx } from "react/jsx-runtime";
const SeatMapProduct = _ref => {
  let {
    bounds,
    form,
    isSelected,
    onChangeSelection,
    priceRaw,
    setIsSeatMapModalOpen
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const {
    p
  } = useProperty();
  const rootElement = useRef(null);
  const readMoreContent = t('seatMapReadMoreContent');
  const additionalInformation = t('seatMapAdditionalInformation');
  const description = t('seatMapDescription');
  const title = t('seatMapTitle');
  useLinksAccessibility({
    targetElement: rootElement,
    productTitle: title
  });
  const extraProps = {
    ...getSingleChoiceProps(t, p, nonDebugT),
    onButtonChange: value => {
      if (value === 'true') {
        setIsSeatMapModalOpen(true);
        analytics.pushToDataLayer({
          event: 'seatingVisible',
          seatingOnPage: value === 'true' ? 'YES' : 'NO'
        });
      }
    },
    normalize: value => {
      return {
        value
      };
    }
  };
  const illustrationUrl = useIllustration(SEAT_MAP.name);
  const productPrice = isSelected ? priceRaw : getMinPrice(bounds);
  const productOptions = {
    priceRaw: productPrice
  };
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, productOptions);
  const readMoreButtonLabel = getReadMoreLabel(t);
  const productData = {
    additionalInformation,
    extraProps,
    description,
    form,
    illustrationUrl,
    isSelected,
    price,
    priceLabel,
    priceRaw: productPrice,
    priceSuffix,
    productId: SEAT_MAP.id,
    productName: SEAT_MAP.name,
    readMoreButtonLabel,
    readMoreContent,
    title,
    isHighlighted: false,
    shouldDisplayUpsell: false
  };
  useDidUpdateEffect(() => {
    let timeoutId;
    if (!isSelected) {
      timeoutId = setTimeout(() => {
        var _document$querySelect;
        (_document$querySelect = document.querySelector('#seatMap_false')) === null || _document$querySelect === void 0 || _document$querySelect.focus();
      }, 300);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [isSelected]);
  return /*#__PURE__*/_jsx(ProductLayout, {
    productData: productData,
    ref: rootElement,
    children: isSelected && /*#__PURE__*/_jsx(ChangeSelection, {
      onClick: onChangeSelection
    })
  });
};
export default SeatMapProduct;
//# sourceMappingURL=SeatMapProduct.js.map